import { plaintextValidator } from '../fields';

const config = { mandatory: true };

export default {
  quantity: plaintextValidator(config),
  unit: plaintextValidator(config)
};
